import {axios} from "../../../../axiosConfig";

const getCalendarEvents = async() => {
    // Función para obtener todos los eventos con paginación
    const fetchAllEvents = async () => {
        let allEvents = [];
        let offset = 0;
        const limit = 200; // Usar chunks de 200 para no sobrecargar
        let hasMore = true;
        
        while (hasMore) {
            try {
                const {data} = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/v1/events`, {
                    params: {
                        limit: limit,
                        offset: offset
                    }
                });
                
                if (data.data && data.data.length > 0) {
                    allEvents = [...allEvents, ...data.data];
                    offset += limit;
                    
                    // Si recibimos menos eventos que el límite, no hay más
                    if (data.data.length < limit) {
                        hasMore = false;
                    }
                    
                    // Limitar a un máximo de 5000 eventos para evitar problemas de memoria
                    if (allEvents.length >= 5000) {
                        console.warn('Se alcanzó el límite máximo de 5000 eventos');
                        hasMore = false;
                    }
                } else {
                    hasMore = false;
                }
            } catch (error) {
                console.error('Error fetching events batch:', error);
                hasMore = false;
            }
        }
        
        console.log(`Total de eventos obtenidos: ${allEvents.length}`);
        return allEvents;
    };
    
    return await fetchAllEvents();
}

export default getCalendarEvents;
